import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const links = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/about', label: 'About' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
    window.scrollTo(0, 0);
  }, [pathname]);

  const solid = scrolled || open;

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${solid ? 'bg-background-50/95 backdrop-blur border-b border-background-300/60' : 'bg-transparent border-b border-transparent'}`}>
      <nav className="mx-auto max-w-[1280px] px-4 md:px-8 lg:px-10 h-[80px] grid grid-cols-[1fr_auto] md:grid-cols-[1fr_auto_1fr] items-center">
        <Link to="/" className="flex items-center gap-3 cursor-pointer" aria-label="Redline Garage home">
          <span className="w-[6px] h-7 bg-primary-500 -skew-x-[20deg]" />
          <span className="font-heading italic text-[26px] tracking-[0.02em] uppercase leading-none">Redline<span className="text-primary-500">-Garage</span></span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end
              className={({ isActive }) => `text-[12px] font-medium uppercase tracking-[0.2em] whitespace-nowrap cursor-pointer transition-opacity py-2 text-white ${isActive ? 'opacity-100' : 'opacity-70 hover:opacity-100'}`}
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center justify-end gap-3">
          <Link to="/contact" className="hidden md:inline-block py-2 text-[12px] font-medium uppercase tracking-[0.2em] text-white opacity-70 hover:opacity-100 whitespace-nowrap cursor-pointer transition-opacity">
            Book Service
          </Link>
          <button type="button" onClick={() => setOpen((o) => !o)} className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer" aria-label="Toggle menu" aria-expanded={open}>
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-300/60 bg-background-50 px-4 pb-6 pt-2">
          {[...links, { to: '/contact', label: 'Contact' }].map((l) => (
            <NavLink key={l.to} to={l.to} end className={({ isActive }) => `block py-3.5 border-b border-background-200 text-base cursor-pointer ${isActive ? 'text-white' : 'text-white/70'}`}>
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="block py-3.5 text-base uppercase tracking-[0.16em] text-white/80 hover:text-white whitespace-nowrap cursor-pointer">
            Book Service
          </Link>
        </div>
      )}
    </header>
  );
}